import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser, loginUser } from "../services/firebase";

const campuses = ["Bulacan", "Gapan"];
const roles = ["teacher", "finance", "uniforms", "books", "admin", "superadmin"];

function AuthForm({ setUser }) {
  const navigate = useNavigate();
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [campus, setCampus] = useState(campuses[0]);
  const [role, setRole] = useState(roles[0]);
  const [userProfile, setUserProfile] = useState(null);
  const [error, setError] = useState("");

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const profile = await registerUser(email, password, campus, role);
      setUserProfile(profile);
      if (setUser) {
        setUser(profile);
        localStorage.setItem("user", JSON.stringify(profile));
        const r = String(profile.role || "").toLowerCase();
        const rs = Array.isArray(profile.roles) ? profile.roles.map(x => String(x).toLowerCase()) : [];
        const has = (name) => r === name || rs.includes(name);
        if (has("admin") || has("finance") || has("superadmin")) navigate("/finance/dashboard");
        else if (has("uniforms")) navigate("/uniforms/inventory");
        else if (has("books")) navigate("/books");
        else if (has("teacher")) navigate("/teacher/dashboard");
        else navigate("/");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const profile = await loginUser(email, password);
      setUserProfile(profile);
      if (setUser) {
        setUser(profile);
        localStorage.setItem("user", JSON.stringify(profile));
        const r = String(profile.role || "").toLowerCase();
        const rs = Array.isArray(profile.roles) ? profile.roles.map(x => String(x).toLowerCase()) : [];
        const has = (name) => r === name || rs.includes(name);
        if (has("admin") || has("finance") || has("superadmin")) navigate("/finance/dashboard");
        else if (has("uniforms")) navigate("/uniforms/inventory");
        else if (has("books")) navigate("/books");
        else if (has("teacher")) navigate("/teacher/dashboard");
        else navigate("/");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "2rem auto", padding: "2rem", border: "1px solid #ccc", borderRadius: 8 }}>
      <h2>{isRegister ? "Register" : "Login"}</h2>
      <form onSubmit={isRegister ? handleRegister : handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          required
          onChange={e => setEmail(e.target.value)}
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          required
          onChange={e => setPassword(e.target.value)}
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        {isRegister && (
          <>
            <select value={campus} onChange={e => setCampus(e.target.value)} style={{ width: "100%", marginBottom: 10, padding: 8 }}>
              {campuses.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <select value={role} onChange={e => setRole(e.target.value)} style={{ width: "100%", marginBottom: 10, padding: 8 }}>
              {roles.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
          </>
        )}
        <button type="submit" style={{ width: "100%", padding: 10, background: "#1976d2", color: "#fff", border: "none", borderRadius: 4 }}>
          {isRegister ? "Register" : "Login"}
        </button>
      </form>
      <button
        onClick={() => setIsRegister(!isRegister)}
        style={{ marginTop: 10, width: "100%", padding: 8, background: "#eee", border: "none", borderRadius: 4 }}
      >
        {isRegister ? "Already have an account? Login" : "No account? Register"}
      </button>
      {error && <div style={{ color: "red", marginTop: 10 }}>{error}</div>}
      {userProfile && (
        <div style={{ marginTop: 20, padding: 10, background: "#f5f5f5", borderRadius: 4 }}>
          <h4>Welcome, {userProfile.email}!</h4>
          <p><strong>Campus:</strong> {userProfile.campus}</p>
          <p><strong>Role:</strong> {userProfile.role}</p>
        </div>
      )}
    </div>
  );
}

export default AuthForm;
